<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Számlatömbök</span>
      <el-button
        v-can="'invoicebook.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/sales/invoice-books/add')"
      >
        Új számlatömb
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="invoiceBook/fetchAll"
      />
    </div>
    <invoiceBook-list style="min-height: 100px;" />
    <template v-if="$route.meta.showViewInvoiceBookDialog">
      <InvoiceBookViewDialog
        :invoiceBookId="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showAddInvoiceBookDialog">
      <invoiceBook-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateInvoiceBookDialog">
      <invoiceBook-dialog
        :invoiceBookId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import InvoiceBookList from '../../components/sales/invoiceBooks/List';
  import InvoiceBookDialog from '../../components/sales/invoiceBooks/Dialog';
  import TableFilter from '../../components/TableFilter';
  import InvoiceBookViewDialog from '../../components/sales/invoiceBooks/View';

  export default {
    components: {
      InvoiceBookList,
      InvoiceBookDialog,
      TableFilter,
      InvoiceBookViewDialog
    },
    data() {
      return {
        filterConfig: null,
        loading: false,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
        let currencies = this.$store.getters['currency/currencies'];
        let invoiceBookTemplates = await axios.get('api/invoice-book-templates');
        let ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        let storages = this.$store.getters['storage/storages'];
        if (!currencies.length) {
          await this.$store.dispatch('currency/fetchAll');
          currencies = this.$store.getters['currency/currencies'];
        }
        if(!ownCompanies.length) {
          await this.$store.dispatch('ownCompany/fetchAll');
          ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        }
        if(!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if (!glaNumbers.length) {
          await this.$store.dispatch('glaNumber/fetchAll');
          glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true,
          },
          {
            type: 'select',
            name: 'currency_id',
            options: currencies,
            label: 'Deviza',
            labelCallback: currency => currency.name,
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'gla_number_id',
            options: glaNumbers,
            label: 'Főkönyvi szám',
            labelCallback: glaNumber => glaNumber.value,
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'default_copies',
            label: 'Alapértelmezett példányszám',
          },
          {
            type: 'select',
            name: 'invoice_book_template_id',
            options: invoiceBookTemplates,
            label: 'Sablon',
            labelCallback: ibt => ibt.name,
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'is_product_billable',
            options: [
              {
                label: 'Igen',
                value: 1
              },
              {
                label: 'Nem',
                value: 0
              },
            ],
            label: 'Termék számlázandó',
            labelCallback: ipb => ipb.label,
            valueKey: 'value',
          },
          {
            type: 'select',
            name: 'is_service_billable',
            options: [
              {
                label: 'Igen',
                value: 1
              },
              {
                label: 'Nem',
                value: 0
              },
            ],
            label: 'Szolgáltatás számlázandó',
            labelCallback: isb => isb.label,
            valueKey: 'value',
          },
          {
            type: 'select',
            name: 'is_real',
            options: [
              {
                label: 'Igen',
                value: 1
              },
              {
                label: 'Nem',
                value: 0
              },
            ],
            label: 'Valódi tömb',
            labelCallback: isReal => isReal.label,
            valueKey: 'value',
          },
          {
            type: 'select',
            name: 'own_company_id',
            options: ownCompanies,
            label: 'Saját cég',
            labelCallback: ownCompany => ownCompany.name,
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'prefix',
            label: 'Előtag',
          },
          {
            type: 'text',
            name: 'region',
            label: 'Régió',
          },
          {
            type: 'select',
            name: 'storage_id',
            options: storages,
            label: 'Raktár',
            labelCallback: storage => storage.name,
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>

